import gql from 'graphql-tag';

export const USER_INVENTORY_BY_KEY_QUERY = gql`
  query UserInventoryItemBalance($key: String!) {
    userInventoryItemBalance(key: $key)
  }
`;

export const MODIFY_USER_INVENTORY = gql`
  mutation ModifyUserInventory(
    $addItems: [AddToInventoryInput!]!
    $removeItems: [RemoveFromInventoryInput!]!
  ) {
    modifyUserInventory(addItems: $addItems, removeItems: $removeItems) {
      updatedBalances {
        key
        amount
      }
    }
  }
`;
